import React from 'react';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { createOpenAIModalCommand } from '../../decoration/actions';
function convertConfigItemToAction(_ref) {
  var _config$icon;
  var config = _ref.config,
    aiGlobalOptIn = _ref.aiGlobalOptIn,
    intl = _ref.intl,
    view = _ref.view;
  return {
    id: config.key.toString(),
    title: intl.formatMessage(config.title),
    description: intl.formatMessage(config.description),
    icon: ((_config$icon = config.icon) === null || _config$icon === void 0 ? void 0 : _config$icon.call(config, {
      formatMessage: intl.formatMessage
    })) || /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
      label: "",
      spacing: "spacious"
    }),
    onClick: function onClick() {
      view.focus();
      createOpenAIModalCommand({
        state: view.state,
        configItem: config,
        lastTriggeredFrom: 'rovoButton',
        aiGlobalOptIn: aiGlobalOptIn
      })(view.state, view.dispatch);
    },
    closePanelOnSelection: true,
    status: config.statusLozengeType
  };
}
export var mapConfigItemsToActions = function mapConfigItemsToActions(_ref2) {
  var intl = _ref2.intl,
    dynamicSurfaceConfigItems = _ref2.dynamicSurfaceConfigItems,
    aiGlobalOptIn = _ref2.aiGlobalOptIn;
  return function (view) {
    var parentConfigItems = dynamicSurfaceConfigItems.reduce(function (accumulator, configItem) {
      var nestingConfig = configItem.config.nestingConfig;
      if (nestingConfig) {
        if (!accumulator[nestingConfig.id]) {
          accumulator[nestingConfig.id] = [];
        }
        accumulator[nestingConfig.id].push(configItem);
      }
      return accumulator;
    }, {});
    var processedParentConfigItem = [];
    var actions = [];
    dynamicSurfaceConfigItems.forEach(function (_ref3) {
      var config = _ref3.config;
      if (config.nestingConfig) {
        if (!processedParentConfigItem.includes(config.nestingConfig.id)) {
          var _config$nestingConfig, _config$nestingConfig2;
          processedParentConfigItem.push(config.nestingConfig.id);
          var childrenConfigItems = parentConfigItems[config.nestingConfig.id];
          var childrenActions = childrenConfigItems.map(function (configItem) {
            return convertConfigItemToAction({
              config: configItem.config,
              aiGlobalOptIn: aiGlobalOptIn,
              intl: intl,
              view: view
            });
          });
          actions.push({
            id: config.nestingConfig.id,
            title: intl.formatMessage(config.nestingConfig.parentTitle),
            description: intl.formatMessage(config.nestingConfig.parentTitle),
            icon: ((_config$nestingConfig = (_config$nestingConfig2 = config.nestingConfig).icon) === null || _config$nestingConfig === void 0 ? void 0 : _config$nestingConfig.call(_config$nestingConfig2, {
              formatMessage: intl.formatMessage
            })) || /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
              label: "",
              spacing: "spacious"
            }),
            children: childrenActions,
            status: config.statusLozengeType
          });
        }
      } else {
        actions.push(convertConfigItemToAction({
          config: config,
          aiGlobalOptIn: aiGlobalOptIn,
          intl: intl,
          view: view
        }));
      }
    });
    return actions;
  };
};

/**
 * Give separate list of config items for;
 * - which can run only on empty document
 * - which can run only on non empty document
 * - which can run only on selection
 */
export function getConfigItemsListForSelection(dynamicSurfaceConfigItems) {
  /**
   * Empty document config items are for prompts:
   * - which can run when document is empty. Currently we have only one empty prompt - Brainstorm.
   */
  var emptyDocConfigItems = dynamicSurfaceConfigItems.filter(function (configWithOptions) {
    var emptyTrigger = configWithOptions.triggers.empty;
    return emptyTrigger && emptyTrigger.enabled && emptyTrigger.docMinSize === 0;
  });
  /**
   * Non empty document, but selection without content config items are for prompts:
   * - which can run only on non-empty documents (e.g improve writing, change tone etc)
   */
  var nonEmptyDocConfigItems = dynamicSurfaceConfigItems.filter(function (configWithOptions) {
    var emptyTrigger = configWithOptions.triggers.empty;
    return emptyTrigger.enabled && (!emptyTrigger.docMinSize || emptyTrigger.docMinSize >= 0);
  });

  /**
   * Selection with content config items are for prompts:
   * - which can run only on selection (e.g Convert to table, convert to bullet list etc)
   */
  var selectionConfigItems = dynamicSurfaceConfigItems.filter(function (configWithOptions) {
    var selectionTrigger = configWithOptions.triggers.selection;
    return selectionTrigger.enabled && (!selectionTrigger.selectionMinSize || selectionTrigger.selectionMinSize >= 0);
  });
  return {
    emptyDocConfigItems: emptyDocConfigItems,
    nonEmptyDocConfigItems: nonEmptyDocConfigItems,
    selectionConfigItems: selectionConfigItems
  };
}
export function getActionsListForSelection(_ref4) {
  var intl = _ref4.intl,
    dynamicSurfaceConfigItems = _ref4.dynamicSurfaceConfigItems,
    aiGlobalOptIn = _ref4.aiGlobalOptIn,
    view = _ref4.view;
  var _getConfigItemsListFo = getConfigItemsListForSelection(dynamicSurfaceConfigItems),
    emptyDocConfigItems = _getConfigItemsListFo.emptyDocConfigItems,
    nonEmptyDocConfigItems = _getConfigItemsListFo.nonEmptyDocConfigItems,
    selectionConfigItems = _getConfigItemsListFo.selectionConfigItems;
  var emptyDocActions = mapConfigItemsToActions({
    aiGlobalOptIn: aiGlobalOptIn,
    dynamicSurfaceConfigItems: emptyDocConfigItems,
    intl: intl
  })(view);
  var nonEmptyDocActions = mapConfigItemsToActions({
    aiGlobalOptIn: aiGlobalOptIn,
    dynamicSurfaceConfigItems: nonEmptyDocConfigItems,
    intl: intl
  })(view);
  var selectionActions = mapConfigItemsToActions({
    aiGlobalOptIn: aiGlobalOptIn,
    dynamicSurfaceConfigItems: selectionConfigItems,
    intl: intl
  })(view);
  return {
    emptyDocActions: emptyDocActions,
    nonEmptyDocActions: nonEmptyDocActions,
    selectionActions: selectionActions
  };
}
export function chooseActionsToShowForSelection(_ref5, _ref6) {
  var isEmptyDoc = _ref5.isEmptyDoc,
    isEmptySelection = _ref5.isEmptySelection;
  var emptyDocActions = _ref6.emptyDocActions,
    nonEmptyDocActions = _ref6.nonEmptyDocActions,
    selectionActions = _ref6.selectionActions;
  if (isEmptyDoc) {
    return emptyDocActions;
  } else if (isEmptySelection) {
    return nonEmptyDocActions;
  } else {
    return selectionActions;
  }
}